<template>
  <v-expansion-panels class="mb-5">
    <v-expansion-panel v-for="(branch, index) in payments.invoice_by_branches" :key="index">
      <v-expansion-panel-header class="no-padding d-flex px-1">
        <v-divider vertical />
        <div class="d-flex align-end pb-4">
          <div class="d-flex align-center pl-3">
            <v-checkbox
              :input-value="isSelected(branch)"
              @click.native.stop
              @change="toggleSelection(payments, branch)"
              class="ma-0 pa-0"
              hide-details
              dense
            />
          </div>
          <div class="pl-2 mr-auto">
            <h6 class="body-2 grey--text text--darken-2">
              <span class="d-block grey--text font-weight-bold caption mt-2">
                {{ $t('hausefulInvoices.subsidiary') }}
              </span>
              {{ branch.branch.name }}
            </h6>
          </div>
          <div class="text-right mx-3">
            <h5 class="d-block body-2 success--text">
              <span class="d-block grey--text font-weight-bold caption mt-2">
                {{ $t('hausefulInvoices.total') }}
              </span>
              {{ totalAmount(branch.hauseful_total) }}
            </h5>
          </div>
          <div class="mx-3 d-flex align-center">
            <v-btn
              @click.stop.prevent="callGenerateAsaasModal(payments, branch)"
              class="invoice-actions__main"
              color="primary"
              outlined
            >
              <v-icon left small>
                mdi-file-document-plus-outline
              </v-icon>
              <span class="caption">
                {{ $t('hausefulInvoices.modals.generateAsaas.action') }}
              </span>
            </v-btn>
            <v-menu offset-y bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click.stop.prevent
                  class="invoice-actions__more px-0"
                  color="primary"
                  min-width="36"
                  outlined
                >
                  <v-icon small>
                    mdi-chevron-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="callUploadModal(payments, branch)">
                  <v-icon class="mr-3 grey--text text--lighten-1" small left>
                    mdi-upload
                  </v-icon>
                  <v-list-item-title class="caption">
                    {{ $t('hausefulInvoices.modals.upload.title') }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="no-padding">
        <InvoiceTable :branch="branch" />
      </v-expansion-panel-content>
      <v-divider class="ml-1" />
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import InvoiceTable from './InvoiceTable'
import { catalogMonetary } from '@/util/catalog'
import { buildSelectableInvoice } from '@/views/invoices/hauseful/invoiceSelection'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'HausefulInvoiceBranch',

  components: {
    InvoiceTable,
  },

  props: {
    payments: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(['selectedHausefulInvoices']),
  },

  methods: {
    ...mapActions(['openModal']),
    ...mapMutations(['setHausefulInvoiceData', 'setHausefulInvoiceInfo', 'toggleHausefulInvoiceSelection']),

    isSelected(branchInfo) {
      const { key } = buildSelectableInvoice(this.payments, branchInfo)
      return this.selectedHausefulInvoices.some((invoice) => invoice.key === key)
    },

    toggleSelection(paymentsInfo, branchInfo) {
      this.toggleHausefulInvoiceSelection(buildSelectableInvoice(paymentsInfo, branchInfo))
    },

    totalAmount(amount) {
      return catalogMonetary(amount ?? 0.00)
    },

    callUploadModal(paymentsInfo, branchInfo) {
      if (!this.prepareInvoiceData(paymentsInfo, branchInfo)) return
      this.openModal('HAUSEFUL_INVOICE_UPLOAD_MODAL')
    },

    callGenerateAsaasModal(paymentsInfo, branchInfo) {
      if (!this.prepareInvoiceData(paymentsInfo, branchInfo)) return
      this.openModal('HAUSEFUL_INVOICE_GENERATE_ASAAS_MODAL')
    },

    prepareInvoiceData(paymentsInfo, branchInfo) {
      if (!paymentsInfo || !branchInfo) return false

      const invoiceInfo = {
        realEstate: paymentsInfo.real_estate.name,
        branch: branchInfo.branch.name ?? null,
        cnpj: paymentsInfo.real_estate.cnpj,
        branchCnpj: branchInfo.branch.cnpj,
        total: branchInfo.hauseful_total,
      }

      const paymentsIds = Array.from(
        branchInfo.payments_invoices,
        ({ payment_id }) => payment_id
      )

      const invoice = {
        real_estate_id: paymentsInfo.real_estate.id,
        branch_id: branchInfo.branch.id ?? null,
        total: branchInfo.hauseful_total,
        payments_ids: paymentsIds,
      }

      this.setHausefulInvoiceData(invoice)
      this.setHausefulInvoiceInfo(invoiceInfo)
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
// Split button: main action joined to the dropdown arrow that holds the secondary action.
.invoice-actions__main.v-btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.invoice-actions__more.v-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left-width: 0;
}
</style>
